import React from 'react'
import { LoggedOutHeader } from '../Headers'
import Footer from '../Footer'

const DefaultRegularPages = ({ landingPageRefs, children }) => {
  return (
    <>
      <LoggedOutHeader landingPageRefs={landingPageRefs} />
      <main data-testid="main">{children}</main>
      <Footer />
    </>
  )
}

export default DefaultRegularPages
